import React from 'react';
import { useTranslation } from 'react-i18next';
import EditIcon from '@wix/da-ds/pkg/Icons/24x24/Edit';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
const EditConfigButton = ({ className, onClick, disabled })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(TextButton, {
        variant: "edit-purple",
        size: "medium",
        icon: EditIcon,
        onClick: onClick,
        disabled: disabled,
        className: className,
        "data-role": "edit-control",
        biData: BiData({
            evid: 278,
            widgetname: BiContextProvidedValue,
            widgetzone: BiContextProvidedValue
        })
    }, t('gruser.widgetbox.button.edit'));
};
EditConfigButton.displayName = 'EditConfigButton';
export default EditConfigButton;

//# sourceMappingURL=EditConfigButton.js.map